import { Card, Form, Stack } from "react-bootstrap";
import { formatPrice } from "../services/formatterService";

const OrderDetails = ({product}) => {

    return (
        <Card className="mt-5">
            <Card.Body>
                <Card.Title>Twoje zamówienie</Card.Title>
                <Form>
                <div className="row mt-4">
                        <div className="col-6 ">
                           <strong>Produkt</strong> 
                        </div>
                        <div className="col-6  text-center">
                            <strong>Kwota</strong> 
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-6">
                            {product.product_name}
                        </div>
                        <div className="col-6 text-center">
                        {formatPrice(product.list_price)} PLN
                            
                        </div>
                    </div>
                </Form>
            </Card.Body>
        </Card>
    );
    }

export default OrderDetails;

//   {
//     "product_id": "9875b208-6051-456f-9d23-066374c6fd84",
//     "product_name": "KURS ONLINE- Analiza danych w HR",
//     "brand_id": 1,
//     "category_id": 1,
//     "list_price": 250,
//     "description": "Dostęp na 12 miesięcy do kursu online"
// }